import * as React from "react";
import { useEffect, useState, useMemo } from "react";
import closeIcon from "src/assets/images/close-ic.png";
import BOMImg from "src/assets/images/bom.png";
import dataSheetImg from "src/assets/images/datasheet-black.png";
import AddToCart from "../../component/Global/Cart/AddToCart";
import QuantityPicker from "../../component/Global/Cart/QuantityPicker";
import store from "../../storeWire";
import { system_notification } from "../../store/slice/system";
import { useSelector } from "react-redux";
import ProductCompareRepository from "../../repository/ProductCompareRepository";
import RefreshStockButton from "../ProductListing/RefreshStockButton";
import DisplayQtyMinQtyMult from "../../component/Product/DisplayQtyMinQtyMult";
import DisplayLifeCycleRisk from "../../component/Product/DisplayLifeCycleRisk";
import PriceTable from "../../component/Global/Cart/PriceTable";
import useCheckAuthPermissions from "src/hooks/component/useCheckAuthPermissions";
import RoleAndPermission from "src/helper/RoleAndPermission";
import liveAuth from "src/helper/liveAuth";
import System from "../../helper/system";
import ProductPricingRepository from "src/repository/ProductPricingRepository";
import ProductInventoryRepository from "src/repository/ProductInventoryRepository";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { Tooltip } from "src/component/Tooltip";
import { NonLoginSignInButton } from "src/reusable/global";
import ProductLegends from "../ProductListing/ProductLegends";
import noImage from 'src/assets/images/noimage.png'
import { useCartStore } from "src/hooks/cart";
import { useProductPricingStore } from "src/hooks/productPricing";
import useReduxState from "src/hooks/useReduxState";
import { useProductInventoryStore } from "src/hooks/productInventory";
import Constants from "src/support/Constants";
import ReusableDiv from "src/support/ReusableDiv";
import Helper from "../../support/Helper";
import NavigateToPDP from "src/component/Global/Product/NavigateToPDP";
import ProductInventoryDisplay from "../../component/Global/Product/ProductInventoryDisplay";
import FactoryLeadTimeDisplay from "src/component/Product/FactoryLeadTimeDisplay";
import newImg from "src/assets/images/new.png";

const CompareProductTable = ({ setShowError, setNoProductError }) => {
  const [_check_p] = useCheckAuthPermissions();
  const data = useSelector((state) => state.entities.model_ProductCompare.data);
  const [productList, setProductList] = useReduxState({}, 'setProductList');
  const [products, SetProducts] = useState([]);
  const [manufacturer, Setmanufacturer] = useState([]);
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [__check] = useAxiosIndicatorCheck();
  const [productInventoryList, setProductInventoryList] = useReduxState([], 'setProductInventoryList');
  const [productPricingList, setProductPricingList] = useReduxState([], 'setProductPricingList');
  const [structureHierarchyArray, setStructureHierarchyArray] = useState([]);
  const [{ CART_BEFORE_TO_SEND_SERVER }, { get_updated_qty }, { }] = useCartStore();
  const [{ pricingList }, { fetch_product_pricing_list }, { }] = useProductPricingStore();
  const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
  const [attributes, setAttributes] = useState();
  const [{ }, { fetch_product_inventory_list }, { }] = useProductInventoryStore();
  const [isGetAssets, set_IsGetAssets] = useState(true);
  const [, { get_inventory_by_id }] = useProductInventoryStore();
  let orderBlock = System.getOrderBlockCreditRiskFlagBySpeedboat().isOrderBlock;
  const channel = useMemo(
      () => new BroadcastChannel("product-compare-toggled"),
      []
  );
  // DT - 8/8/23 - 13298: Compare Product: On deleting any part from the compare list it reloads the whole page
  // channel.addEventListener("message", async () => {
  //   // window.location.reload();
  // });

  useEffect(() => {
    async function fetchHere() {
      if (data) {
        let d = [];
        Object.entries(data).map((v) => {
          d.push(v[1]);
        });
        if (d.length > 0) {
          await setProductList(data);

          if (isGetAssets) { //Note: When delete product - restrict inventory /pricing call
            // set_loadfetchInventoryFromServer(true);

            // DT - 13141 - 14/8/23 - Inventory and price calls are made sequentially instead of parallel
            let inventory = {};
            // await setProductInventoryList(
            //   await new ProductInventoryRepository().fetchProductInventoryByProducts(data)
            // );
            setFirstServerCall(false)
            await Promise.all([
              new ProductInventoryRepository().fetchProductInventoryByProducts(data),
              fetchPricingFromServer(data)
            ]).then((res) => {
              inventory = res[0];
            }).catch(() => { });

            setProductInventoryList(inventory)

            // set_loadfetchInventoryFromServer(false);
          } else { set_IsGetAssets(true) }

        } else {
          setProductList({});
          if (!isGetAssets) {
            set_IsGetAssets(true)
            setNoProductError(true)
          }

        }
      }

    }

    fetchHere();
  }, [data]);

  useEffect(() => {
    if (__check(['PRODUCT_COMPARE_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status === false) {
      if (data === undefined || Object.entries(data).length === 0) {
        setNoProductError(true)
      } else {
        setNoProductError(false);
      }
    }

  }, [__check(['PRODUCT_COMPARE_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status])

  useEffect(() => {
    async function fetchHere() {
      await getAllData();
    }

    fetchHere();
  }, [productList]);

  useEffect(() => {
    if (products.length > 0) {
      products.map((product) => {
        setStructureHierarchyArray((prevState) => [...prevState,
          { ItemRowNumber: product.ItemRowNumber, StructureHierarchy: product.StructureHierarchy, },
        ]);
      });
    }
  }, [products]);

  useEffect(() => {
    if (structureHierarchyArray.length > 1) {
      setShowError(!validateAllCatagories(structureHierarchyArray));
      setNoProductError(false);
    }
  }, [structureHierarchyArray, products]);

  useEffect(() => {
    setProductPricingList(pricingList)
    if (firstServerCall === false && authLoggedIn() && !monitorFunctionCall) {
      Helper.monitorJSDx()
      setMonitorFunctionCall(true)
    }
  }, [pricingList])

  const fetchPricingFromServer = async (productData) => {

    if (productData && Object.keys(productData).length > 0) {
      let params = [];
      Object.entries(productData).map((v) => {
        params.push({
          partNumber: v[1]?.ERPPartNumberModified ? '' : v[1].ERPPartNumber,
          erpManufacturerCode: v[1].ERPManufacturerCode,
          erpMfrPartNumber: v[1].ERPMFRPartNumber,
          WebCode: v[1].WebCode,
          ObsoleteFlag: v[1].ObsoleteFlag,
        })
      });
      if (isGuestFullRights()) {
        let paramSet = await new ProductPricingRepository().getPricingParams(params);
        await fetch_product_pricing_list(paramSet)
      }
    }

  };

  function validateAllCatagories(array) {
    const arrayWithCatagories = [];

    if (array.length > 1) {
      array.map((item) =>
          !arrayWithCatagories.includes(item.StructureHierarchy) &&
          arrayWithCatagories.push(item.StructureHierarchy)
      );
    }

    const result = arrayWithCatagories.every((element) => {
      if (element === arrayWithCatagories[0]) {
        return true;
      }
    });

    return result;
  }

  const getProductPricing = (ERPMFRPartNumber, ERPPartNumber, ERPPartNumberModified) => {
    ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber;
    if (productPricingList && productPricingList[ERPMFRPartNumber + '-' + ERPPartNumber]) {
      return productPricingList[ERPMFRPartNumber + '-' + ERPPartNumber];
    }
    return [];
  };

  const getProductInventoryQuantityByERPPartNumber = (ERPPartNumber, getObject = false) => {
    if (productInventoryList && productInventoryList[ERPPartNumber] !== undefined &&
        productInventoryList[ERPPartNumber].quantity !== undefined) {
      if (getObject) {
        return productInventoryList[ERPPartNumber];
      } else {
        return productInventoryList[ERPPartNumber].quantity;
      }
    }
    if (getObject) {
      return { quantity: 0, qus: 0, };
    }
    return 0;
  };

  const deleteProduct = async (product) => {
    set_IsGetAssets(false);
    const structureHierarchyArrayWithoutRemovedItem = structureHierarchyArray.filter((item) => item.ItemRowNumber != product.ItemRowNumber);
    setStructureHierarchyArray(structureHierarchyArrayWithoutRemovedItem);
    await new ProductCompareRepository().toggleSingleProduct(product);
    // new BroadcastChannel("product-compare-toggled").postMessage({}); // 13300 - remove broadcast to mange seprate tab while different speeboat
    await new ProductCompareRepository().fetchAllData();
  };

  const getAttrKeys = () => {
    let keyAry = [];
    if (productList && Object.keys(productList).length > 0) {
      Object.keys(productList).map(
          (v, i) => {
            let attr = productList[v].Attributes.map(f => f.ATTRNAME)
            if (keyAry?.length > 0) {
              keyAry = keyAry.concat(attr)
            } else {
              keyAry = attr
            }
          })
    }

    keyAry = [...new Set(keyAry)];

    return keyAry;
  }


  const getAllData = async () => {
    if (productList && Object.keys(productList).length > 0) {
      setNoProductError(false)
      let productData = [];
      let manufacturerData = [];

      let keyAry = getAttrKeys();
      keyAry = keyAry.map(obj => ({ key: obj, value: [] }))

      Object.keys(productList).map(
          (v, i) => {
            productData.push({
              ...productList[v],
              manufacturerName: productList[v].Manufacturer ? productList[v].Manufacturer : ""
            })

            manufacturerData.push({
              ERPManufacturerName: productList[v].Manufacturer ? productList[v].Manufacturer : "",
            })

            keyAry.map((k, idx) => {
              let attr = productList[v].Attributes.find(f => f.ATTRNAME === k.key)?.ATTRVAL
              k.value.push(attr ? attr : "NA")
            });
          }
      );
      SetProducts(productData);

      Setmanufacturer(manufacturerData);
      setAttributes(keyAry);
    }

  };

  const showFarnellInventory = (ERPPartNumber) => {
    System.popup('FarnellInventoryStockPopup', {
        ERPPartNumber
    })
  }

  const refreshStock = async () => {
    await fetchInventoryFromServer()
  }

  const fetchInventoryFromServer = async () => {
    if (products && products.length > 0) {
      let params = [];
      products.map((v) => {
        !v?.ERPPartNumberModified && params.push({
          sboat: System.auth('speedBoat'),
          ERPManufacturerCode: v.ERPManufacturerCode,
          ERPPartNumber: v.ERPPartNumber,
        })
      });

      params.length > 0 && await fetch_product_inventory_list(params)
    }
  };

  const authLoggedIn = (keyIndex) => {
    return liveAuth.check();
  };

  const openContactUsPopup = () => {
    store.dispatch(
        system_notification({
          name: "ContactUsPopup",
          data: { restrict: true, order_block: orderBlock },
        })
    );
  };

  const openQuotePopup = (e) => {
    if (_check_p("PD_CLICK_TO_QUOTE").status === false || _check_p("PDT_CLICK_TO_QUOTE").status === false) {
      openContactUsPopup();
      return false;
    }
    !authLoggedIn()
        ? System.popup("GuestPopupActionButton", {
          title: "Request A Quote",
          body: "Sign in to request a quote.",
        })
        : store.dispatch(
            system_notification({
              name: "QuotePopup",
              data: {
                single_product: e,
                addFrom: 'Compare'
              },
            })
        );
  };

  const openAddToBOM = (e) => {
    if (_check_p("PD_ADD_TO_BOM").status === false) {
      openContactUsPopup();
      return false;
    }
    const _product = get_updated_qty(e, CART_BEFORE_TO_SEND_SERVER);
    store.dispatch(
        system_notification({
          name: "AddToBOMPopup",
          data: {
            single_product: _product,
            addFrom: 'Compare'
          },
        })
    );
  };

  const isAuthAccountLess = () => {
    return _check_p('PD_ADD_TO_BOM').status === true
  }

  const getGuestDisplayTooltipButton = (v) => {
    return (isGuestFullRights() || isAuthAccountLess()) ? (
        <a href={void 0} className="img-text" onClick={() => openAddToBOM(v)}>
          <img src={BOMImg} />
          <span className="blue text">Add To BOM</span>
        </a>
    ) : (
        <Tooltip position={"bottom center"}
                 opener={() => (
                     <a href={void 0} className="img-text btn-unauthorize">
                       <img src={BOMImg} />
                       <span className="blue text">Add To BOM</span>
                     </a>
                 )}
                 content={() => (
                     <>
                       <div dangerouslySetInnerHTML={{
                         __html: RoleAndPermission.getGuestErrorForBOMCart(),
                       }}
                       ></div>
                     </>
                 )}
        />
    );
  };

  const isGuestFullRights = () => {
    return _check_p("PDG_ADD_TO_CART").status && _check_p("PDG_ADD_TO_BOM").status && _check_p("PDG_CLICK_TO_QUOTE").status;
  };

  const openGuestPopUp = (title, body) => {
    System.popup("GuestPopupActionButton", { title: title, body: body });
  };

  /**
   * Bug    #  : 9670
   * Change #  : Display download message on download
   * Change by : PN
   * Date      : 4 Aug 2023
   */
  const showDownloadMessage = () => {
    System.alert(Constants.downloadMsg, 'success')
  }

  return (
      <>
        <div className="table-responsive">
          {productList && Object.keys(productList).length > 0 &&
              (
                  <table className="copmare-product-table table table-bordered table-striped">
                    <thead>
                    <tr>
                      <th colSpan={8}>PRODUCTS</th>
                    </tr>
                    <tr className="white-bg">
                      {products.map((v, i) => (
                          <td key={i} className="align-top">
                            <div className="compare-product-detail">
                              <div className="compare-product-title">
                                <NavigateToPDP data={{
                                  ManufacturerName: v?.manufacturerName,
                                  ERPMFRPartNumber: v?.ERPMFRPartNumber,
                                  ItemNumber: v?.ItemNumber,
                                }} >
                                  {v.ERPMFRPartNumber}
                                </NavigateToPDP>
                                <div className="close-ic"
                                     onClick={async () => { await deleteProduct(v) }}
                                >

                                  <img src={closeIcon} />
                                </div>
                              </div>
                              <div className="copmare-product-info">
                                <div className="product-img text-center ">
                                  <img src={v.AssetURL !== undefined && v.AssetURL !== null && v.AssetURL.trim() !== '' ? v.AssetURL : noImage} />
                                </div>

                                <div className="sect-row">
                                  {v.ERPPartNumber !== "" && v.ERPPartNumber !== " " && v.ERPPartNumber !== null && (
                                      <div className="add-to-bom">
                                        {authLoggedIn() === false ? (
                                            <a href={void 0} className="img-text"
                                               onClick={() =>
                                                   openGuestPopUp(
                                                       "BOM Upload",
                                                       "Sign-in to upload BOM."
                                                   )
                                               }
                                            >
                                              <img src={BOMImg} />
                                              <span className="blue text">
                                      Add To BOM
                                    </span>
                                            </a>
                                        ) : (getGuestDisplayTooltipButton(v))}
                                      </div>
                                  )}
                                  {v.DatasheetUrl ? <div className="datasheet">
                                            <a className="datasheet-align img-text" rel="nofollow"
                                               href={v.DatasheetUrl}
                                               onClick={() => showDownloadMessage()}
                                               title={
                                                   v.ManufacturerPartNumber + " Datasheet"
                                               }
                                               target="_new">
                                              <img src={dataSheetImg} />
                                              <span className="blue text">Datasheet</span>
                                            </a>
                                          </div> : ReusableDiv.dataSheetTooltip()
                                  }

                                  <DisplayLifeCycleRisk single_product={v} />
                                </div>
                              </div>
                              {authLoggedIn(i) && v.ERPPartNumber !== "" &&
                                  v.ERPPartNumber !== " " && v.ERPPartNumber !== null && (
                                      <div className="col-auto p-0 copmare-product-add-remove">
                                        <div className="text-left small-text light light-text collapse_minmax">
                                          <DisplayQtyMinQtyMult single_product={v} />
                                        </div>
                                        <div>
                                          <QuantityPicker
                                              single_product={v}
                                              single_product_pricing_list={getProductPricing(
                                                  v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified
                                              )}
                                              single_product_inventory={getProductInventoryQuantityByERPPartNumber(
                                                  v.ERPPartNumber,
                                                  true
                                              )}
                                          />
                                        </div>
                                        <div>
                                          <AddToCart
                                              single_product_pricing_list={getProductPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)}
                                              single_product_inventory={getProductInventoryQuantityByERPPartNumber(v.ERPPartNumber, true)}
                                              single_product={v}
                                              isFrom="Compare"
                                          />
                                        </div>
                                        <div className="mt-2">
                                        </div>
                                      </div>
                                  )}
                            </div>
                          </td>
                      ))}
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colSpan={8}>
                        <b>Manufacturer</b>
                      </td>
                    </tr>
                    <tr className="white-bg">
                      {manufacturer.map((v, i) => (
                          <td key={i}
                              // className="cursor-pointer"
                              //   onClick={() =>
                              //   (window.location.pathname = `/wps/portal/${System.siteName()}/manufacturers/m/${v.ERPManufacturerName?.toLowerCase()
                              //     .replace(/\+/g, "and")
                              //     .replace(/\&/g, "and")
                              //     .replace(/\./g, "")
                              //     .replace(/\//g, "-")
                              //     .replace(/\,/g, "")
                              //     .replace(/\s/g, "-")
                              //     .replace(/\---/g, "-")}`)
                              //   }
                          >
                            {v.ERPManufacturerName}
                          </td>
                      ))}
                    </tr>
                    <tr>
                      <td colSpan={8}>
                        <b> Availability</b>
                        <RefreshStockButton
                            fetchInventoryFromServer={refreshStock}
                        />
                      </td>
                    </tr>
                    <tr className="white-bg">
                      {/* {products.map((v, i) => (
                    <td key={i}>
                      <ProductInventoryDisplay single_product={v} isFrom={Constants.isFrom.COMPARE} single_product_inventory={get_inventory_by_id(v?.ERPPartNumber)} />
                    </td>
                  ))} */}
                      {products.map((v, i) => (
                          <td key={i}>
                            <ul className="list-text availibility-list-text">
                              <li className="text-darkgreen">
                                <i className="fa fa-check-circle me-1"
                                   style={{ visibility: __check(['PRODUCT_INVENTORY_API_CALL']).status ? 'hidden' : 'visible' }} />
                                <span className="d-flex text-darkgreen w-100">
                            <b>In Stock</b>
                            <b className="ms-auto">
                              {" "}
                              {getProductInventoryQuantityByERPPartNumber(
                                  v.ERPPartNumber
                              )}{" "}
                            </b>
                          </span>
                              </li>
                              <li>
                                <div id="availability_cont_3_lead_time" className="grey" >
                                  <div className="addtn-inventory leadTime">
                                    <strong>ADDITIONAL INVENTORY</strong>
                                    <div className="clearfix">
                                      <FactoryLeadTimeDisplay
                                          single_product={v}
                                          single_product_inventory={getProductInventoryQuantityByERPPartNumber(
                                              v.ERPPartNumber,
                                              true
                                          )}
                                      />
                                    </div>
                                  </div>
                                  {v?.FarnellInventorySharing &&
                                      <div>
                                        <a href={void (0)} className="d-flex align-items-center justify-content-center mt-2 m-auto text-blue cursor-pointer" onClick={() => showFarnellInventory(v.ERPPartNumber)}> <img src={newImg} />
                                          <Tooltip
                                              position={'top center'}
                                              opener={() => (
                                                  <span className="text-ports ms-2"><b>Stock from Farnell, an Avnet company</b></span>
                                              )}
                                              content={() => (
                                                  <>
                                                    <div>
                                                      Farnell, an Avnet company offers a wide range of products to meet your needs.
                                                    </div>
                                                  </>
                                              )} /></a>
                                      </div>
                                  }
                                </div>
                              </li>
                            </ul>
                          </td>
                      ))}
                    </tr>
                    {!orderBlock &&
                        <tr>
                          <td colSpan={8}>
                            <b>Price</b>
                          </td>
                        </tr>
                    }

                    <tr className="white-bg compared-product-price">
                      {products.map((v, i) =>
                          authLoggedIn(i) &&
                          v.ERPPartNumber !== "" &&
                          v.ERPPartNumber !== " " &&
                          v.ERPPartNumber !== null &&
                          isGuestFullRights() ? (
                              <td key={i}>
                                <PriceTable
                                    linesToDisplay={100}
                                    single_product={v}
                                    single_product_inventory={getProductInventoryQuantityByERPPartNumber(
                                        v.ERPPartNumber,
                                        true
                                    )}
                                    single_product_pricing_list={getProductPricing(
                                        v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified
                                    )}
                                />
                                {v && !v.ObsoleteFlag && getProductPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)?.length > 0 &&
                                    <p className="quite-link">
                                      Need more?
                                      {_check_p("PDG_CLICK_TO_QUOTE").status &&
                                          _check_p("PDTG_CLICK_TO_QUOTE").status && (
                                              <a onClick={(e) => openQuotePopup(v)}>
                                                {" "}
                                                Click to Quote
                                              </a>
                                          )}
                                      {(_check_p("PDG_CLICK_TO_QUOTE").status === false ||
                                          _check_p("PDTG_CLICK_TO_QUOTE").status === false) && (
                                          <Tooltip
                                              position={"bottom center"}
                                              opener={() => (
                                                  <a
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                      }}
                                                      className={"text-blue unauthorize-link"}
                                                  >
                                                    {" "}
                                                    Click To Quote
                                                  </a>
                                              )}
                                              content={() => (
                                                  <>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                              RoleAndPermission.guestErrorTooltip(),
                                                        }}
                                                    ></div>
                                                  </>
                                              )}
                                          />
                                      )}
                                    </p>
                                }
                              </td>
                          ) : (
                              <td key={i}>
                                <NonLoginSignInButton
                                    isAuthAccLess={
                                        authLoggedIn() && isGuestFullRights() === false
                                    }
                                    isGuestAccess={!authLoggedIn()}
                                    compare_product={true}
                                />
                              </td>
                          )
                      )}
                    </tr>

                    <tr>
                      <td colSpan={8}>
                        <b>Information</b>
                      </td>
                    </tr>
                    <tr className="white-bg">
                      {products.map((v, i) => (
                          <td key={i} className="pb-0">
                            <ul className="list-text list-text-inline d-flex flex-wrap">
                              <ProductLegends single_product={v} onlyIconTitle={true} />
                            </ul>
                          </td>
                      ))}
                    </tr>


                    {attributes && attributes.length > 0 &&
                        attributes.map((v) => (
                            <React.Fragment key={v.key}>
                              <tr>
                                <td colSpan={8}>
                                  <b> {v.key} </b>
                                </td>
                              </tr>
                              <tr className="white-bg">
                                {v.value.map((k, idx) => (
                                    <td key={idx}>{k}</td>
                                ))}
                              </tr>
                            </React.Fragment>
                        ))
                    }

                    </tbody>
                  </table>
              )}
        </div >
      </>
  );
};

export default CompareProductTable;
